import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminAPI } from '@/lib/api';
import { toast } from 'sonner';
import { LogIn } from 'lucide-react';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await adminAPI.login(credentials);
      // SECURITY NOTE: Using localStorage for token storage
      // Limitation: Vulnerable to XSS attacks if malicious scripts are injected
      // Production recommendation: Implement httpOnly cookies with secure flag
      // Alternative: Use session-based authentication with CSRF protection
      localStorage.setItem('adminToken', response.data.access_token);
      toast.success('ورود موفق');
      navigate('/admin/dashboard');
    } catch (error) {
      toast.error('نام کاربری یا رمز عبور اشتباه است');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="max-w-md w-full glass-effect border border-white/10 rounded-2xl p-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-light text-white mb-2" data-testid="login-title">ورود مدیریت</h1>
          <p className="text-zinc-400">پنل مدیریت ARYA MOHAJER ASIA</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm text-zinc-300 mb-2">نام کاربری</label>
            <input
              type="text"
              required
              data-testid="username-input"
              value={credentials.username}
              onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
              className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-white focus:border-[#D4AF37] focus:outline-none focus:ring-1 focus:ring-[#D4AF37]"
            />
          </div>
          <div>
            <label className="block text-sm text-zinc-300 mb-2">رمز عبور</label>
            <input
              type="password"
              required
              data-testid="password-input"
              value={credentials.password}
              onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
              className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-white focus:border-[#D4AF37] focus:outline-none focus:ring-1 focus:ring-[#D4AF37]"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="login-button"
            className="w-full px-6 py-4 bg-[#D4AF37] text-black rounded-full font-medium hover:bg-[#F3E5AB] transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
          >
            {loading ? 'در حال ورود...' : 'ورود'}
            <LogIn size={20} />
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;